import { Auth } from 'aws-amplify';

export type ForgotPassword = {
  email: string;
};

export function forgotPasswordApi(data: ForgotPassword) {
  return Auth.forgotPassword(data.email);
}
